import { render, staticRenderFns } from "./ViewLogisticReport.vue?vue&type=template&id=33c5d43c&scoped=true"
import script from "./ViewLogisticReport.vue?vue&type=script&lang=ts"
export * from "./ViewLogisticReport.vue?vue&type=script&lang=ts"
import style0 from "./ViewLogisticReport.vue?vue&type=style&index=0&id=33c5d43c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33c5d43c",
  null
  
)

export default component.exports